<template>
  <div v-if="dataReady && object && object.id > 0">
    <div class="row text-white inner-row" style="background: #e6ab8e">
      <div class="col-md-10" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b>{{object.name + ' (' + object.owner + ')'}}</b>
      </div>
      <div class="col-md-2" style="text-align: right">
        <i class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
      </div>
    </div>

    <simple-row :name="'Название документа'" :value="fieldView(object.name)"></simple-row>
    <simple-row :name="'Документ относится к'" :value="fieldView(object.owner)"></simple-row>
    <simple-row :name="'Файл-шаблон'" :value="object.pattern ? fieldView(object.pattern.name) : 'Выбрать'"
                @clicked="object.pattern ? fileView=true : inFileSelect=true"></simple-row>
    <file-edit :item="{object: object.pattern}" v-if="inFileSelect"
               :parent="'doc_pattern'" :parent-id="object.id" :update-file="true"
               @toView="updatePattern"></file-edit>
    <file-view v-if="object.pattern && fileView && !inFileSelect"
               :item="{object: object.pattern}"
               @toEdit="inFileSelect = true"
               @toRow="fileView=false"></file-view>
    <div v-if="object.pattern && object.pattern.id > 0 && dataReady">
      <br/>
      <p>Поля для автозаполнения в документе:</p>
      <div :key="fieldsKey">
        <div v-for="(item, index) in object.fields" :key="index">
          <doc_field_pattern :item="{object: item}" :field-types="fieldTypes" :entities="entities"></doc_field_pattern>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" style="text-align: left">
          <b v-on:click="addField" >Обновить поля</b>
        </div>
        <div class="col-md-6" style="text-align: right">
          <b v-on:click="saveFields">Сохранить поля</b>
        </div>
      </div>

    </div>
  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";

 export default {
   components: {
     SimpleRow
   },
   props:{
     item: {}
   },
   data() {
     return {
       tableKey: 0,
       object: this.item.object,
       inFileSelect: false,
       fileView: false,
       dataReady: false,
       links: [],
       fieldTypes: [],
       entities: [],
       fieldsKey: 0
    }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     },
     async update() {
       this.item.object = await this.$repo.get(this.object.id, 'doc_pattern');
       this.object = this.item.object;
     },
     async updatePattern() {
       await this.update();
       this.inFileSelect = false;
     },
     async addField() {
       this.object.fields = await this.$repo.getByURL('doc_pattern/fields/' + this.object.id);
       this.fieldsKey++;
     },
     saveFields() {
       this.$repo.saveByLink(this.object.fields, 'doc_pattern/fields/' + this.object.id);
       this.fieldsKey++;
     }
   },
   async mounted() {
     this.links = await this.$repo.getSelector('admin/document_field_links/' + this.object.owner);
     this.entities = await this.$repo.getSelector("admin/entities_types");
     this.fieldTypes = await this.$repo.getSelector("admin/document_field_types");
     if (this.object.fields) {
       this.object.fields.forEach(field =>
           field.entity = field.entity ? field.entity : this.object.owner
       )
     }
     this.dataReady = true;
   }
 }
</script>
<style>
</style>
